import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_2 = { class: "mt-8 d-grid grid-cols-2 products-container d-md-flex flex-md-wrap justify-content-center align-items-center gap-4 mx-2" }
const _hoisted_3 = { class: "img-container-width aspect-square d-flex justify-content-center align-items-center rounded-5 overflow-hidden bg-white p-2 p-md-4" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  id: "product-title",
  class: "mt-3 h5 text-center line-clamp-2 overflow-hidden text-ellipsis"
}
const _hoisted_6 = { class: "d-flex m-0 p-0 flex-column text-lg-start" }

import Footer from "@/components/Footer.vue";
import LoadingError from "@/components/LoadingError.vue";
import { useProductsStore } from "@/stores/ProductsStore";
import { onMounted, toRefs } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductsView',
  setup(__props) {

const productsStore = useProductsStore();
const { products, error, loading, didFetchOnce } = toRefs(productsStore);

onMounted(() => {
  if (!didFetchOnce.value) {
    productsStore.fetchProducts();
    productsStore.setDidFetchOnce(true);
  }
});

const shortTitle = (text: string, length: number = 30) => (text.length > length ? text.slice(0, length) + "..." : text);

return (_ctx: any,_cache: any) => {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LoadingError, {
      error: _unref(error),
      loading: _unref(loading)
    }, null, 8, ["error", "loading"]),
    (!_unref(loading))
      ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
          _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-center my-4 text-4xl" }, "Products", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "max-w-lg text-center mx-auto" }, " Our products combine quality, innovation, and reliability to meet your needs. Whether it’s gadgets, essentials, or unique finds, we have something for everyone. Explore our collection and discover the perfect fit for your lifestyle! ", -1)),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(products), (product) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "flex-md-grow-1 flex-shrink-1 p-3 custom-shadow rounded",
                key: product.id
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    class: "w-100 mx-auto object-fit",
                    src: product.image,
                    alt: "Product Image",
                    "aria-labelledby": "product-title"
                  }, null, 8, _hoisted_4)
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("h3", _hoisted_5, _toDisplayString(shortTitle(product.title, 17)), 1),
                _createElementVNode("p", _hoisted_6, [
                  _createElementVNode("span", null, "Price: " + _toDisplayString(product.price) + "$", 1),
                  _createElementVNode("span", null, [
                    _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Rating:", -1)),
                    _createTextVNode(" " + _toDisplayString(product.rating.rate) + " ⭐", 1)
                  ]),
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(product.rating.count) + " reviews ", 1),
                    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-chat-left-text ms-2" }, null, -1))
                  ])
                ])
              ])), [
                [_directive_auto_animate]
              ])
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(Footer)
  ], 64))
}
}

})